import React from 'react'
import lumiere from '../assets/images/lumiere.PNG'
import algues from '../assets/images/algues.PNG'
import growing from '../assets/images/growing.PNG'
import racines from '../assets/images/racines.PNG'
import machine from '../assets/images/machine.PNG'
import Header from '../components/Header'
import '../assets/styles/court.css'
import { Link } from 'react-router-dom'

function Court() {
  return (
    <div id="topCourt" className="courtContainer">
      <Header />
          <div className="courtTitle">
            <h1>Court-métrages</h1>
          </div>
          <div className="listCourt">
            <Link to="/lumiereResume"><img src={lumiere} alt="affiche lumière"/></Link>
            <Link to="/algues"><img src={algues} alt="affiche algues"/></Link>
            <Link to="/growing"><img src={growing} alt="affiche growing"/></Link>
            <Link to="/racines"><img src={racines} alt="affiche racines"/></Link>
            <Link to="/machine"><img src={machine} alt="affiche machine"/></Link>
          </div>
          <div className="buttonRetour">
          <a href='#topCourt'><button id="buttonRetourAccueil">RETOUR</button></a>
          </div>
    </div>
  )
}

export default Court